<box class="popup-info">
    <form [formGroup]="formGroup" (ngSubmit)="submit()" class="form-group entry-form" autocomplete="off">
        <ng-container *ngIf="_responsive.isMobile()">
            <box class="doc-upload">
                <box class="form-title-group">
                    <ng-container *ngIf="_helper._commonService.isHybrid(); else notHybridHeader">
                        <!-- <h2 class="upload-title">Upload Photo</h2> -->
                        <box class="label-txt">
                            <label class="description"> Support file formats <span>JPEG,JPG,PNG,bmp,.gif.</span>File
                                size should be less than <span>2MB</span></label>
                        </box>
                    </ng-container>
                    <ng-template #notHybridHeader>
                        <!-- <h2 class="upload-title">Upload Photo</h2> -->
                        <box class="label-txt">
                            <label class="description"> Support file formats <span>JPEG,JPG,PNG,bmp,.gif.</span>File
                                size should be less than<span>2MB</span> </label>
                        </box>
                    </ng-template>
                </box>
                <box class="field-group">
                    <box class="fpx-form-control">
                        <box class="fpx-field-content upload-doc-button-grp">
                            <box class="pic-chooser">
                                <box class="camera-button" *ngIf="_helper._commonService.isHybrid()">
                                    <button type="button" rel="camera" class="upload-doc-button"
                                        (click)="_helper.startTakePhoto($event)">
                                        <span class="img-ico"><img src="./assets/images/cob-camera.svg"
                                                alt="document" /></span>
                                        <span class="button-txt">Take a<br />Photo</span>
                                    </button>
                                </box>

                                <box class="file-browse">
                                    <app-file-browse-button class="upload-document-button" destinationType="file"
                                        [acceptImages]="state.acceptimages" (fileSelect)="_helper.onFileSelect($event)"
                                        label="Choose from Gallery"></app-file-browse-button>
                                </box>
                            </box>
                        </box>
                    </box>
                </box>
            </box>
        </ng-container>
        <ng-container *ngIf="_responsive.isDesktop()">
            <box class="doc-upload">
                <box class="form-title-group">
                    <ng-container *ngIf="_helper._commonService.isHybrid(); else notHybridHeader">
                        <!-- <h2 class="upload-title">Upload Photo</h2> -->
                        <box class="label-txt">
                            <label class="description"> Support file formats <span>JPEG,JPG,PNG,bmp,.gif.</span>File
                                size should be less than <span>2MB</span>
                            </label>
                        </box>
                    </ng-container>
                    <ng-template #notHybridHeader>
                        <!-- <h2 class="upload-title">Upload Photo</h2> -->
                        <box class="label-txt">
                            <label class="description"> Support file formats <span>JPEG,JPG,PNG,bmp,.gif.</span><br>File
                                size should be less than <span>2MB</span></label>
                        </box>
                    </ng-template>
                </box>
                <box class="field-group">
                    <box class="fpx-form-control">
                        <box class="fpx-field-content upload-doc-button-grp">
                            <box class="pic-chooser">
                                <box class="camera-button" *ngIf="_helper._commonService.isHybrid()">
                                    <button type="button" rel="camera" class="upload-doc-button"
                                        (click)="_helper.startTakePhoto($event)">
                                        <span class="img-ico"><img src="./assets/images/cob-camera.svg"
                                                alt="document" /></span>
                                        <span class="button-txt">Take a<br />Photo</span>
                                    </button>
                                </box>

                                <box class="file-browse">
                                    <app-file-browse-button class="upload-document-button" destinationType="file"
                                        [acceptImages]="state.acceptimages" (fileSelect)="_helper.onFileSelect($event)"
                                        label="Browse to Upload"></app-file-browse-button>
                                </box>
                            </box>
                        </box>
                    </box>
                </box>
            </box>
        </ng-container>
    </form>
</box>
